export default __webpack_public_path__ + "static/media/seller_payment_advice.d33b729d.xlsx";